import React from "react";
import { useState } from "react";
import Baseindex from "../About/base";
export default function ContactIndex() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [description, setDescription] = useState("");
  const [country, setCountry] = useState("");
  const [phonenumber, setPhoneNumber] = useState("");
  const [jobtitle, setJobtitle] = useState("");
  const [companyName, setCompanyName] = useState("");
  return (
    <>
      <div> 
        <div className="text-whitepage flex justify-center items-center flex-col  pb-6">
          <div className="text-4xl mb-12 mt-8 ">
            <div className="ml-2"> Let us know how we can be of help</div>
            <div className="ml-52"></div>
          </div>
          <div className="text-2xl ">
            <div className="ml-2">
              {" "}
              Please enter your information and describe your inquiry,{" "}
              we will get back to you.
            </div>
            <div className="ml-44"></div>
          </div>
        </div>
        <div>
          <form>
            <div className="w-full">
              <label
                for="small-input"
                class="block mb-2 text-sm font-medium text-whitepage "
              >
                Business Email Address
              </label>
              <input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
                type="email"
                name="email"
                required
                className="w-full"
              />
            </div>
            <div className="w-full flex justify-between flex-row">
              <div className="w-1/2">
                <label
                  for="small-input"
                  class="block mb-2 text-sm font-medium text-whitepage "
                >
                  First Name
                </label>
                <input
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  placeholder="First name"
                  type="text"
                  name="firstName"
                  required
                  className="w-full"
                />
              </div>
              <div className="w-1/2">
                <label
                  for="small-input"
                  class="block mb-2 text-sm font-medium text-whitepage "
                >
                  Last Name
                </label>
                <input
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  placeholder="Last name"
                  type="text"
                  name="lastName"
                  required
                  className="w-full"
                />
              </div>
            </div>
            <div className="w-full flex justify-between flex-row">
              <div className="w-1/2">
                <label
                  for="small-input"
                  class="block mb-2 text-sm font-medium text-whitepage "
                >
                  Company Name
                </label>
                <input
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                  placeholder="Name"
                  type="text"
                  name="companyname"
                  required
                  className="w-full"
                />
              </div>
              <div className="w-1/2">
                <label
                  for="small-input"
                  class="block mb-2 text-sm font-medium text-whitepage "
                >
                  Job Title
                </label>
                <input
                  value={jobtitle}
                  onChange={(e) => setJobtitle(e.target.value)}
                  placeholder="Job title"
                  type="text"
                  name="jobtitle"
                  required
                  className="w-full"
                />
              </div>
            </div>
            <div className="w-full">
              <label
                for="small-input"
                class="block mb-2 text-sm font-medium text-whitepage "
              >
                Phone Number
              </label>
              <input
                value={phonenumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                placeholder="Phone Number"
                type="tel"
                name="phonenumber"
                required
                className="w-full"
              />
            </div>
            <div className="w-full">
              <label
                for="small-input"
                class="block mb-2 text-sm font-medium text-whitepage "
              >
                Country
              </label>
              <input
                value={country}
                onChange={(e) => setCountry(e.target.value)}
                placeholder="Company"
                type="text"
                name="country"
                required
                className="w-full"
              />
            </div>

            <div className="w-full">
              <label
                for="small-input"
                class="block mb-2 text-sm font-medium text-whitepage "
              >
                Request description
              </label>
              <input
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="........"
                type="text"
                name="description"
                required
                className="w-full"
              />
            </div>
            <div className="w-3/12">
              <button type="submit">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
      <div className="px-24 content-start flex-col  p-4 justify-center  flex">
        <Baseindex />
      </div>
    </>
  );
}
